<template lang="html">
    <div class="container">

        <div class="header">
            <p class="select">
                {{data.pname}}
                <i class="iconfont icon-fanhui" @click="back"></i>
            </p>
        </div>


        <div class="listtxt">
            <h2>
                {{data.first_party}}
                <br>
                {{data.rname}}
            </h2>
            <ul>
                <li>
                    <p>
                        责任人
                        <span>{{data.uname}}</span>
                    </p>
                </li>


                <li>
                    <p>
                        制作部
                        <span>{{data.gname}}</span>
                    </p>
                </li>


                <li>
                    <p>
                        合同金额
                        <span>¥{{data.tmony}}</span>
                    </p>
                </li>



                <li>
                    <p>
                        已回款金额
                        <span>¥{{data.bmoney}}</span>
                    </p>
                </li>



                <li>
                    <p>
                        合同
                        <span class="look nodata" :class="{'nodata':data.hasContract == 0}">查看详情</span>
                    </p>
                </li>



                <li>
                    <p @click="showLetter">
                        开工函
                        <!-- <span class="look" :class="{'nodata':data.hasLetter == 0}">查看详情</span> -->
                        <span class="look nodata">查看详情</span>
                    </p>
                    <mt-popup v-model="popupVisible">
                      <img src="" alt="" class="letter" id="letter">
                    </mt-popup>
                </li>


                <li>
                    <p>
                        交稿时间
                        <span>{{data.completed_date}}</span>
                    </p>
                </li>

                <li>
                    <p>
                        完成状态
                        <span>{{data.hasComplete == 0 ? '未完成' : '已完成'}}</span>
                    </p>
                </li>


                <li>
                    <p>
                        预计交付时间
                        <span>{{data.end_date}}</span>
                    </p>
                </li>

            </ul>
        </div>



    </div>
</template>

<script>
import { Popup } from 'mint-ui'
import config from '../fetch/config'
import Vue from 'vue'
Vue.component(Popup.name, Popup)
  export default {
    data () {
      return {
        data:null,
        popupVisible: false,
      }
    },
    methods: {
      showLetter () {
        if (this.data.hasLetter == 0 ) {
            return false
        } else {
            // this.$http.getLetter(this.data.letter).then( res => {
            //   console.log(res)
            // })
           var _this = this
           var oReq = new window.XMLHttpRequest()
           oReq.open('POST', `${config.baseURL}mbph/mobile/getUpyunFile`, true)
           oReq.responseType = 'blob'
           oReq.setRequestHeader('IM-TOKEN', window.localStorage.getItem('token'))
           oReq.setRequestHeader('Content-type', 'application/x-www-form-urlencoded')
           oReq.onreadystatechange = function () {
               if (oReq.readyState === oReq.DONE) {
                 _this.popupVisible = true
                 var blob = oReq.response
                 var image = document.getElementById('letter')
                 image.addEventListener('load', function (evt) {
                     window.URL.revokeObjectURL(evt.target.src)
                 })
                 image.src = window.URL.createObjectURL(blob)
               }
           }
           oReq.send("path=" + this.data.letter )
        }
      },
      getSrc (url) {
        return `${config.baseURL.substring(0,config.baseURL.length-1)}${url}`
      },
      back () {
        this.$router.push({name:'analyze'})
      },

    },
    created () {
      this.data = this.$route.params.data
    },
  }

</script>

<style lang="css" scoped>
    .container {
        height: 100%;
        width: 100%;
        background-color: #fafafa;
        font-family: PingFangSC-Regular;
        overflow: hidden;
    }
    .header{
        width: 100%;
        background: #f5f5f5;
        margin-bottom: 0.21875rem;
    }
    .select{
        width: 100%;
        color: #333333;
        height: 1.1875rem;
        background: #fff;
        font-size: 0.40625rem;
        line-height: 1.1875rem;
        padding-left: 0.34375rem;
        position: relative;
        text-align: center;
        border-bottom: 1px solid #ddd;
        margin-bottom: 0.3125rem;
    }
    .iconfont{
        position: absolute;
        left: 0.3125rem;
        font-weight: bold;
        line-height: 1.1875rem;
    }
    .listtxt{
        color: #333333;
        width: 100%;
        background: #fff;
        height: 100%;
    }
    .listtxt h2{
        color: #333333;
        width: 100%;
        text-align: left;
        font-size: 0.4375rem;
        margin-bottom: 0.15625rem;
        padding-top: 1.0625rem;
        padding-left: 0.8125rem;
    }
    .listtxt ul{
        width: 100%;
    }
    .listtxt ul li{
        height: 0.9375rem;
        line-height: 0.9375rem;
        border-bottom: 1px solid #ddd;
        position: relative;
    }
    .listtxt ul li p{
        color: #333333;
        width: 100%;
        text-align: left;
        font-size: 0.4375rem;
        padding-left: 0.8125rem;
    }
    .listtxt ul li span{
        color: #333333;

        font-size: 0.4375rem;
        position: absolute;
        right: 1.15625rem;
    }
    .look{
        border: 1px solid #5483D2;
        height: 0.625rem;
        line-height: 0.625rem;
        border-radius: 0.125rem;
        font-size: 0.375rem!important;
        margin-top: 2%;
        color: #5483D2!important;
        padding-left: 0.0625rem;
        padding-right: 0.0625rem;
    }
    .nodata{
        border: 1px solid #ddd;
        color: #ddd!important;
    }
    .letter{
      width: 6.25rem;
      height: 9.375rem;
    }


</style>



// WEBPACK FOOTER //
// src/components/AnalyzeClick.vue